<template>
  <div v-if="menus.length > 0">
    <base-menu-card
      v-for="menu in menus"
      :id="menu.id"
      :key="menu.id"
      :title="menu.attributes.name"
      :description="getDescription(menu)"
      :updated-at="menu.attributes.updated_at"
      :link="menu.links.layout"
      :image="menu.attributes.absolute_logo_path ?? null"
      :alt="menu.attributes.logo"
      :embedded="embedded"
      @removeItem="removeMenu"
      @copyItem="copyMenu"
    ></base-menu-card>
    <button v-if="pagination?.next" class="btn btn-primary rounded w-100" @click="fetchMenus(pageSize)">
      <i class="bi bi-caret-down"></i>
      mehr anzeigen
    </button>
    <a v-if="pagination?.next" href="/menus?back=dashboard" class="btn btn-primary w-100 mt-3">
      <i class="bi bi-caret-down-fill"></i>
      alle anzeigen
    </a>
  </div>
  <div v-else class="text-center">
    <div role="alert" class="alert mb-0 alert-dark">
      Sie haben noch keine Karten. Klicken Sie
      <a href="/configuration">hier</a>
      um eine neue Karte zu erstellen.
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';

import useMenus from '@/composables/useMenus';

export default {
  props: {
    pageSize: {
      type: Number,
      default: 5,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { menus, pagination, fetchMenus, removeMenu, copyMenu } = useMenus();

    onMounted(() => {
      fetchMenus(props.pageSize);
    });

    const getDescription = (menu) => {
      const { title, subtitle } = menu.attributes;

      if (title && !subtitle) return title;
      if (subtitle && !title) return subtitle;
      if (title && subtitle) return title + ' - ' + subtitle;

      return '';
    };

    return {
      getDescription,
      menus,
      pagination,
      removeMenu,
      copyMenu,
      fetchMenus,
    };
  },
};
</script>

<style lang="scss" scoped></style>
